import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import jump from 'jump.js';

@Component({
  selector: 'app-sub-footer',
  templateUrl: './sub-footer.component.html',
  styleUrls: ['./sub-footer.component.scss'],
  standalone: false
})
export class SubFooterComponent {
  @Input()
  enableNextStep: boolean;

  @Input()
  nextStep: string;

  @Input()
  listProperty: boolean;

  isAnimationProchaineEtapeDemarree = false;

  constructor(private readonly _router: Router) {}

  navigateTo(target: string): void {
    this._router.navigateByUrl(target);
  }

  defilerVersProchaineEtape() {
    jump('#sub-footer');
  }

  nouvelleVisibiliteProchaineEtape(event) {
    if (event.visible && !this.isAnimationProchaineEtapeDemarree) {
      this.isAnimationProchaineEtapeDemarree = true;
    }
  }

  getBackgroundImageSource() {
    return {
      desktop: '/sub-footer/desktop-fond-de-maison-avec-plaines.svg'
    };
  }
}
